export default {
  common: {
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    confirm: '确认',
    close: '关闭',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息',
    visible: '显示',
    sectionTitle: '区块标题',
    sectionDescription: '区块描述',
    selectLanguage: '选择语言',
    saveChanges: '保存更改',
    saveSuccess: '保存成功',
    title: '标题',
    name: '姓名',
    location: '地点',
    description: '描述',
    imageUrl: '图片URL',
    price: '价格',
    link: '链接',
    copy: '复制',
    paste: '粘贴',
    show: '显示',
    hide: '隐藏',
    action: '操作',
    heroSection: 'Hero部分'
  },
  login: {
    title: 'Travelbolt CMS',
    subtitle: '登录管理您的内容',
    username: '用户名',
    password: '密码',
    signIn: '登录',
    incorrect: '用户名或密码错误',
    failed: '登录失败，请重试',
    successful: '登录成功'
  },
  menu: {
    destinations: '热门目的地',
    flightDeals: '精选航班优惠',
    services: '我们的旅行服务',
    hotDeals: '热门优惠和促销',
    hotDealDetails: '热门优惠详情',
    flashSale: '限时抢购',
    testimonials: '旅行者评价',
    exclusiveDeals: '独家旅行优惠',
    exclusiveTravelInsurance: '独家旅行保险',
    heroBackground: '首页背景图/Logo',
    subscribers: '订阅者管理',
    users: '用户管理',
    languages: '语言管理',
    destinationDetails: '目的地详情',
    flightDealDetails: '航班优惠详情',
    footer: '页脚管理',
    marketing: '营销管理',
    faqs: '常见问题',
    aboutUs: '关于我们',
    contentManagement: '内容管理',
    systemManagement: '系统管理'
  },
  footer: {
    title: '页脚管理',
    companyName: '公司名称',
    companyDescription: '公司描述',
    socialMedia: '社交媒体',
    icon: '图标',
    link: '链接',
    addSocialMedia: '添加社交媒体',
    quickLinks: '快速链接',
    url: '链接地址',
    addQuickLink: '添加快速链接',
    supportLinks: '支持链接',
    addSupportLink: '添加支持链接',
    contactInfo: '联系信息',
    address: '地址',
    phone: '电话',
    email: '邮箱',
    businessHours: '营业时间',
    copyright: '版权信息',
    paymentMethods: '支付方式',
    paymentMethod: '支付方式',
    name: '名称',
    imageUrl: '图片URL',
    addPaymentMethod: '添加支付方式'
  },
  users: {
    title: '用户管理',
    list: '用户列表',
    addUser: '添加用户',
    editUser: '编辑用户',
    deleteUser: '删除用户',
    confirmDelete: '确定要删除这个用户吗？',
    username: '用户名',
    email: '邮箱',
    password: '密码',
    status: '状态',
    createdAt: '创建时间',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '用户更新成功',
    created: '用户创建成功',
    deleted: '用户删除成功',
    failed: '保存用户失败',
    loadFailed: '加载用户失败'
  },
  languages: {
    title: '语言管理',
    list: '语言列表',
    addLanguage: '添加语言',
    editLanguage: '编辑语言',
    deleteLanguage: '删除语言',
    confirmDelete: '确定要删除这个语言吗？',
    code: '代码',
    name: '名称',
    status: '状态',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '语言更新成功',
    created: '语言创建成功',
    deleted: '语言删除成功',
    failed: '保存语言失败',
    loadFailed: '加载语言失败',
    cannotRemoveEnglish: '英语不能被删除'
  },
  destinations: {
    title: '热门目的地',
    add: '添加目的地',
    edit: '编辑目的地',
    name: '名称',
    description: '描述',
    image: '图片',
    link: '链接',
    status: '状态',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '目的地更新成功',
    created: '目的地创建成功',
    deleted: '目的地删除成功',
    failed: '保存目的地失败',
    loadFailed: '加载目的地失败',
    visible: '显示',
    sectionTitle: '区块标题',
    sectionDescription: '区块描述',
    destinations: '目的地',
    destination: '目的地',
    rating: '评分',
    duration: '时长',
    badge: '徽章'
  },
  flightDeals: {
    title: '精选航班优惠',
    add: '添加航班优惠',
    edit: '编辑航班优惠',
    titleField: '标题',
    description: '描述',
    price: '价格',
    image: '图片',
    link: '链接',
    status: '状态',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '航班优惠更新成功',
    created: '航班优惠创建成功',
    deleted: '航班优惠删除成功',
    failed: '保存航班优惠失败',
    loadFailed: '加载航班优惠失败',
    visible: '显示',
    sectionTitle: '区块标题',
    sectionDescription: '区块描述',
    departureOptions: '出发选项',
    travelerOptions: '旅行者选项',
    flightDeals: '航班优惠',
    flightDeal: '航班优惠',
    destination: '目的地',
    dates: '日期',
    prices: '价格',
    originalPrice: '原价',
    discount: '折扣',
    primePriceText: '会员价格文本',
    sellingOut: '即将售罄',
    hot: '热门',
    addDepartureLocation: '添加出发地点',
    addTravelerCount: '添加旅行者数量',
    departureOptionExists: '出发选项已存在',
    itinerary: '行程安排',
    packages: '套餐',
    addItineraryDay: '添加行程日',
    dayTitle: '日标题',
    addActivity: '添加活动',
    activity: '活动',
    addPackage: '添加套餐',
    packageName: '套餐名称',
    packageDescription: '套餐描述',
    packageReviews: '评价数',
    addPackageFeature: '添加套餐特性',
    packageFeature: '套餐特性',
    isPopular: '是否热门',
    isPremium: '是否高级',
    imageUrl: '图片URL',
    subtitle: '副标题',
    heroSection: 'Hero部分'
  },
  services: {
    title: '我们的旅行服务',
    add: '添加服务',
    edit: '编辑服务',
    titleField: '标题',
    description: '描述',
    icon: '图标',
    status: '状态',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '服务更新成功',
    created: '服务创建成功',
    deleted: '服务删除成功',
    failed: '保存服务失败',
    loadFailed: '加载服务失败',
    visible: '显示',
    sectionTitle: '区块标题',
    sectionDescription: '区块描述',
    services: '服务',
    service: '服务'
  },
  hotDeals: {
    title: '热门优惠和促销',
    add: '添加优惠',
    edit: '编辑优惠',
    titleField: '标题',
    description: '描述',
    price: '价格',
    image: '图片',
    link: '链接',
    status: '状态',
    actions: '操作',
    active: '开启',
    inactive: '关闭',
    updated: '优惠更新成功',
    created: '优惠创建成功',
    deleted: '优惠删除成功',
    failed: '保存优惠失败',
    loadFailed: '加载优惠列表失败',
    deals: '优惠列表',
    deal: '优惠',
    addDeal: '添加优惠',
    validDates: '有效期',
    bookingDeadline: '预订截止日期',
    originalPrice: '原价',
    badge: '徽章'
  },
  hotDealDetails: {
    list: '热门优惠详情列表',
    addHotDeal: '添加热门优惠详情',
    editHotDeal: '编辑热门优惠详情',
    dealKey: '优惠标识',
    dealKeyPlaceholder: '输入优惠标识（例如：africa）',
    title: '标题',
    language: '语言',
    status: '状态',
    actions: '操作',
    created: '热门优惠详情创建成功',
    updated: '热门优惠详情更新成功',
    deleted: '热门优惠详情删除成功',
    failed: '保存热门优惠详情失败',
    mapSection: '地图区域',
    detailSection: '详情图文区域',
    itinerarySection: '建议行程区域',
    ctaSection: '行动号召（CTA）',
    sectionTitle: '区域标题',
    sectionDescription: '区域描述',
    enterSectionTitle: '输入区域标题',
    enterSectionDescription: '输入区域描述',
    mapMarkers: '地图标记点',
    marker: '标记点',
    addMarker: '添加标记点',
    countryCode: '国家代码',
    countryName: '国家名称',
    color: '颜色',
    latitude: '纬度',
    longitude: '经度',
    exampleKE: '例如：KE',
    exampleKenya: '例如：肯尼亚',
    countryLabel: '国家标签',
    exampleCountryLabel: '例如：肯尼亚 · 马赛马拉',
    badgeCode: '徽章代码',
    badgeColor: '徽章颜色',
    detailTitle: '详情标题',
    detailDescription: '详情描述',
    enterDetailTitle: '输入详情标题',
    enterDetailDescription: '输入详情描述',
    highlights: '亮点列表',
    highlight: '亮点',
    addHighlight: '添加亮点',
    iconClass: '图标类名',
    iconColor: '图标颜色',
    highlightText: '亮点文字',
    exampleIcon: '例如：fa-binoculars',
    enterHighlightDescription: '输入亮点描述',
    tags: '标签列表',
    addTag: '添加标签',
    enterTagContent: '输入标签内容',
    gallery: '图片画廊',
    image: '图片',
    addImage: '添加图片',
    imageUrl: '图片URL',
    imageDescription: '图片描述',
    imageTitle: '图片标题',
    enterImageUrl: '输入图片URL',
    enterImageDescription: '输入图片描述',
    enterImageTitle: '输入图片标题',
    upload: '上传',
    itineraryDays: '行程天数',
    itinerary: '行程',
    addItinerary: '添加行程',
    dayRange: '天数范围',
    location: '地点',
    description: '描述',
    exampleDayRange: '例如：第 1–4 天',
    exampleLocation: '例如：肯尼亚 · 马赛马拉',
    enterItineraryDescription: '输入行程描述',
    ctaBackgroundImage: 'CTA背景图',
    ctaTitle: 'CTA标题',
    ctaDescription: 'CTA描述',
    ctaButtonText: 'CTA按钮文字',
    ctaButtonLink: 'CTA按钮链接',
    enterCtaTitle: '输入CTA标题',
    enterCtaDescription: '输入CTA描述',
    enterButtonText: '输入按钮文字',
    enterButtonLink: '输入按钮链接'
  },
  flashSale: {
    title: '限时抢购：仅限48小时',
    add: '添加限时抢购',
    edit: '编辑限时抢购',
    titleField: '标题',
    description: '描述',
    price: '价格',
    originalPrice: '原价',
    image: '图片',
    link: '链接',
    status: '状态',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '限时抢购更新成功',
    created: '限时抢购创建成功',
    deleted: '限时抢购删除成功',
    failed: '保存限时抢购失败',
    loadFailed: '加载限时抢购失败',
    countdownEndDate: '倒计时结束日期',
    flashDeals: '限时优惠',
    flashDeal: '限时优惠',
    addFlashDeal: '添加限时优惠',
    discount: '折扣'
  },
  testimonials: {
    title: '旅行者评价',
    add: '添加评价',
    edit: '编辑评价',
    name: '姓名',
    comment: '评价内容',
    rating: '评分',
    image: '图片',
    status: '状态',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '评价更新成功',
    created: '评价创建成功',
    deleted: '评价删除成功',
    failed: '保存评价失败',
    loadFailed: '加载评价失败',
    testimonials: '评价',
    testimonial: '评价',
    addTestimonial: '添加评价',
    avatarUrl: '头像URL',
    review: '评价内容'
  },
  exclusiveDeals: {
    title: '独家旅行优惠',
    add: '添加独家优惠',
    edit: '编辑独家优惠',
    titleField: '标题',
    description: '描述',
    buttonText: '按钮文本',
    image: '图片',
    link: '链接',
    status: '状态',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '独家优惠更新成功',
    created: '独家优惠创建成功',
    deleted: '独家优惠删除成功',
    failed: '保存独家优惠失败',
    loadFailed: '加载独家优惠失败',
    backgroundImageUrl: '背景图片URL',
    newsletterForm: '通讯表单',
    formTitle: '表单标题',
    formDescription: '表单描述',
    successMessage: '成功消息',
    privacyText: '隐私声明文本'
  },
  exclusiveTravelInsurance: {
    title: '独家旅行保险',
    features: '特性',
    feature: '特性',
    addFeature: '添加特性',
    imageUrl: '图片URL',
    buttonText: '按钮文本',
    buttonLink: '按钮链接'
  },
  heroBackground: {
    title: '首页背景图管理',
    imageUrl: '背景图片URL'
  },
  subscribers: {
    title: '订阅者管理',
    sendEmail: '发送邮件',
    emailSubject: '邮件标题',
    emailContent: '邮件内容',
    loading: '加载订阅者中...',
    id: 'ID',
    email: '邮箱',
    name: '姓名',
    phone: '电话',
    status: '状态',
    subscribedAt: '订阅时间',
    lastEmail: '上次发送',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    deactivate: '停用',
    activate: '激活',
    enterEmailSubject: '输入邮件标题',
    enterEmailContent: '输入邮件内容',
    loadFailed: '加载订阅者失败，请重试。',
    loadFailedMessage: '加载订阅者失败',
    activateSuccess: '订阅者激活成功',
    deactivateSuccess: '订阅者停用成功',
    updateFailed: '更新订阅者状态失败',
    enterSubjectAndContent: '请输入标题和内容',
    sendFailed: '发送邮件失败',
    confirmDelete: '确定要删除订阅者 {email} 吗？',
    deleteSuccess: '删除订阅者成功',
    deleteFailed: '删除订阅者失败'
  },
  header: {
    logo: 'Travelbolt CMS',
    logout: '退出登录',
    loggedInAs: '登录用户：'
  },
  destinationDetails: {
    title: '目的地详情管理',
    list: '目的地详情列表',
    addDestination: '添加目的地',
    editDestination: '编辑目的地',
    deleteDestination: '删除目的地',
    confirmDelete: '确定要删除这个目的地吗？',
    destinationKey: '目的地标识',
    destinationKeyPlaceholder: '输入目的地标识（例如：bali）',
    language: '语言',
    title: '标题',
    titlePlaceholder: '输入目的地标题',
    subtitle: '副标题',
    subtitlePlaceholder: '输入目的地副标题',
    rating: '评分',
    reviews: '评价数',
    reviewsPlaceholder: '输入评价数',
    country: '国家',
    countryPlaceholder: '输入国家名称',
    bannerImage: '横幅图片',
    bannerImagePlaceholder: '输入横幅图片URL',
    description: '描述',
    descriptionPlaceholder: '输入目的地描述',
    spots: '秘密景点',
    spot: '景点',
    addSpot: '添加景点',
    spotName: '景点名称',
    spotImage: '景点图片',
    bestTime: '最佳时间',
    location: '位置',
    spotDescription: '景点描述',
    travelTips: '旅行提示',
    tip: '提示',
    addTravelTip: '添加旅行提示',
    tipTitle: '提示标题',
    addTipItem: '添加提示项',
    tipItem: '提示项',
    ctaTitle: 'CTA标题',
    ctaTitlePlaceholder: '输入CTA标题',
    ctaDescription: 'CTA描述',
    ctaDescriptionPlaceholder: '输入CTA描述',
    cta: 'CTA',
    status: '状态',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '目的地更新成功',
    created: '目的地创建成功',
    deleted: '目的地删除成功',
    failed: '保存目的地失败',
    loadFailed: '加载目的地失败'
  },
  flightDealDetails: {
    title: '航班优惠详情管理',
    list: '航班优惠详情列表',
    addFlightDeal: '添加航班优惠',
    editFlightDeal: '编辑航班优惠',
    deleteFlightDeal: '删除航班优惠',
    confirmDelete: '确定要删除这个航班优惠吗？',
    dealKey: '优惠标识',
    dealKeyPlaceholder: '输入优惠标识（例如：london）',
    language: '语言',
    title: '标题',
    titlePlaceholder: '输入航班优惠标题',
    subtitle: '副标题',
    subtitlePlaceholder: '输入航班优惠副标题',
    rating: '评分',
    reviews: '评价数',
    reviewsPlaceholder: '输入评价数',
    country: '国家',
    countryPlaceholder: '输入国家名称',
    bannerImage: '横幅图片',
    bannerImagePlaceholder: '输入横幅图片URL',
    overview: '概览',
    addOverviewFeature: '添加概览特性',
    icon: '图标',
    featureTitle: '特性标题',
    featureDescription: '特性描述',
    itinerary: '行程安排',
    addItinerary: '添加行程',
    addItineraryDay: '添加行程日',
    dayTitle: '日标题',
    addActivity: '添加活动',
    addPackageSection: '添加套餐部分',
    activity: '活动',
    packages: '套餐',
    addPackage: '添加套餐',
    packageName: '套餐名称',
    packageDescription: '套餐描述',
    price: '价格',
    originalPrice: '原价',
    packageReviews: '评价数',
    addPackageFeature: '添加套餐特性',
    packageFeature: '套餐特性',
    isPopular: '是否热门',
    isPremium: '是否高级',
    reviews: '评价',
    addReview: '添加评价',
    reviewerName: '评价者姓名',
    avatar: '头像URL',
    reviewContent: '评价内容',
    reviewDate: '评价日期',
    ctaTitle: 'CTA标题',
    ctaTitlePlaceholder: '输入CTA标题',
    ctaDescription: 'CTA描述',
    ctaDescriptionPlaceholder: '输入CTA描述',
    cta: 'CTA',
    sectionVisibility: '区块可见性',
    reviewsSection: '评价区块',
    addImage: '添加图片',
    sectionTitle: '区块标题',
    description: '描述',
    imageUrl: '图片URL',
    dealKeyRequired: '优惠标识不能为空',
    languageRequired: '语言不能为空',
    titleRequired: '标题不能为空',
    countryRequired: '国家不能为空',
    status: '状态',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '航班优惠更新成功',
    created: '航班优惠创建成功',
    deleted: '航班优惠删除成功',
    failed: '保存航班优惠失败',
    loadFailed: '加载航班优惠失败',
    tripOverview: '行程概览',
    tripOverviewTitle: '行程概览标题',
    tripOverviewDescription: '行程概览描述',
    tripOverviewDays: '天数',
    tripOverviewDaysPlaceholder: '输入行程天数',
    tripOverviewDaysDescription: '天数描述',
    tripOverviewDaysDescriptionPlaceholder: '输入天数描述',
    tripOverviewBestSeason: '最佳季节',
    tripOverviewBestSeasonPlaceholder: '输入最佳季节',
    tripOverviewSeasonDescription: '季节描述',
    tripOverviewSeasonDescriptionPlaceholder: '输入季节描述',
    tripOverviewTravelStyle: '旅行风格',
    tripOverviewTravelStylePlaceholder: '输入旅行风格',
    tripOverviewStyleDescription: '风格描述',
    tripOverviewStyleDescriptionPlaceholder: '输入风格描述',
    labelSettings: '标签设置',
    daysLabel: '行程天数标签',
    daysLabelPlaceholder: '输入行程天数标签',
    seasonLabel: '最佳季节标签',
    seasonLabelPlaceholder: '输入最佳季节标签',
    styleLabel: '旅行风格标签',
    styleLabelPlaceholder: '输入旅行风格标签',
    packageButtonText: '套餐按钮文字',
    packageButtonTextPlaceholder: '输入套餐按钮文字',
    packageButtonLink: '套餐按钮链接',
    packageButtonLinkPlaceholder: '输入套餐按钮链接',
    ctaButtonText: 'CTA按钮文字',
    ctaButtonTextPlaceholder: '输入CTA按钮文字',
    ctaButtonLink: 'CTA按钮链接',
    ctaButtonLinkPlaceholder: '输入CTA按钮链接',
    overviewButtonText: '概览按钮文字',
    overviewButtonTextPlaceholder: '输入概览按钮文字（如：查看6日行程灵感）',
    popularLabelPlaceholder: '人气标签文案（如：人气之选）',
    premiumLabelPlaceholder: '高级标签文案（如：尊享）'
  },
  faqs: {
    title: '常见问题管理',
    addCategory: '添加分类',
    editCategory: '编辑分类',
    addFaq: '添加问题',
    editFaq: '编辑问题',
    title: '标题',
    order: '排序',
    visible: '显示',
    question: '问题',
    answer: '答案',
    faqs: '个问题',
    saveSuccess: '保存成功',
    updateSuccess: '更新成功',
    deleteSuccess: '删除成功',
    saveError: '保存失败',
    updateError: '更新失败',
    deleteError: '删除失败',
    loadError: '加载失败'
  },
  aboutUs: {
    title: '关于我们管理',
    content: '内容',
    hero: 'Hero Section',
    heroTitle: 'Hero Title',
    enterHeroTitle: 'Enter hero title',
    heroSubtitle: 'Hero Subtitle',
    enterHeroSubtitle: 'Enter hero subtitle',
    heroDescription: 'Hero Description',
    enterHeroDescription: 'Enter hero description',
    mission: 'Mission Section',
    missionBadge: 'Mission Badge',
    enterMissionBadge: 'Enter mission badge',
    missionTitle: 'Mission Title',
    enterMissionTitle: 'Enter mission title',
    missionContent: 'Mission Content',
    enterMissionParagraph: 'Enter mission paragraph {index}',
    addMissionParagraph: 'Add Mission Paragraph',
    whyChooseUs: 'Why Choose Us Section',
    whyChooseUsBadge: 'Why Choose Us Badge',
    enterWhyChooseUsBadge: 'Enter why choose us badge',
    whyChooseUsTitle: 'Why Choose Us Title',
    enterWhyChooseUsTitle: 'Enter why choose us title',
    whyChooseUsItems: 'Why Choose Us Items',
    itemIcon: 'Item Icon',
    enterItemIcon: 'Enter item icon',
    itemTitle: 'Item Title',
    enterItemTitle: 'Enter item title',
    itemDescription: 'Item Description',
    enterItemDescription: 'Enter item description',
    addWhyChooseUsItem: 'Add Why Choose Us Item',
    contactInfo: 'Contact Info Section',
    contactInfoBadge: 'Contact Info Badge',
    enterContactInfoBadge: 'Enter contact info badge',
    contactInfoTitle: 'Contact Info Title',
    enterContactInfoTitle: 'Enter contact info title',
    contactInfoDescription: 'Contact Info Description',
    enterContactInfoDescription: 'Enter contact info description',
    officeTitle: 'Office Title',
    enterOfficeTitle: 'Enter office title',
    officeIcon: 'Office Icon',
    enterOfficeIcon: 'Enter office icon',
    office: 'Office',
    enterOffice: 'Enter office address',
    phoneTitle: 'Phone Title',
    enterPhoneTitle: 'Enter phone title',
    phoneIcon: 'Phone Icon',
    enterPhoneIcon: 'Enter phone icon',
    phone: 'Phone',
    enterPhone: 'Enter phone number',
    phoneHours: 'Phone Hours',
    enterPhoneHours: 'Enter phone hours',
    emailTitle: 'Email Title',
    enterEmailTitle: 'Enter email title',
    emailIcon: 'Email Icon',
    enterEmailIcon: 'Enter email icon',
    email: 'Email',
    enterEmail: 'Enter email address',
    emailResponse: 'Email Response',
    enterEmailResponse: 'Enter email response time'
  },
  privacyPolicy: {
    title: '隐私政策管理',
    content: '内容',
    heroTitle: '英雄标题',
    enterHeroTitle: '输入英雄标题',
    heroSubtitle: '英雄副标题',
    enterHeroSubtitle: '输入英雄副标题',
    lastUpdated: '最后更新',
    enterLastUpdated: '输入最后更新日期',
    note: '说明',
    enterNote: '输入说明',
    part1Title: '第一部分标题',
    enterPart1Title: '输入第一部分标题',
    ourPledge: '我们的承诺',
    enterOurPledge: '输入我们的承诺',
    cookies: 'Cookie',
    enterCookies: '输入Cookie文本',
    enterCookiesText1: '输入Cookie文本',
    enterCookiesText2: '输入Cookie文本',
    analytics: '分析',
    enterAnalytics: '输入分析文本',
    enterAnalyticsText: '输入分析文本',
    remarketing: '再营销',
    enterRemarketing: '输入再营销文本',
    enterRemarketingText: '输入再营销文本',
    optingOut: '选择退出',
    enterOptingOut: '输入选择退出文本',
    enterOptingOutText1: '输入选择退出文本',
    enterOptingOutText2: '输入选择退出文本',
    collection: '收集',
    enterCollection: '输入收集文本',
    enterCollectionText1: '输入收集文本',
    enterCollectionText2: '输入收集文本',
    useOfData: '个人数据的使用',
    enterUseOfData: '输入数据使用文本',
    enterUseOfDataText: '输入数据使用文本',
    retention: '保留',
    enterRetention: '输入保留文本',
    enterRetentionText: '输入保留文本',
    access: '访问和更正',
    enterAccess: '输入访问文本',
    enterAccessText1: '输入访问文本',
    accessItem1: '访问项目 1',
    enterAccessItem1: '输入访问项目 1',
    accessItem2: '访问项目 2',
    enterAccessItem2: '输入访问项目 2',
    accessItem3: '访问项目 3',
    enterAccessItem3: '输入访问项目 3',
    accessItem4: '访问项目 4',
    enterAccessItem4: '输入访问项目 4',
    accessItem5: '访问项目 5',
    enterAccessItem5: '输入访问项目 5',
    enterAccessText2: '输入访问文本',
    byPost: '通过邮寄',
    enterAddress: '输入地址',
    byEmail: '通过邮件',
    enterEmail: '输入邮箱',
    enterAccessText3: '输入访问文本',
    security: '安全',
    enterSecurity: '输入安全文本',
    enterSecurityText: '输入安全文本',
    part2Title: '第二部分标题',
    enterPart2Title: '输入第二部分标题',
    enterPersonalInformation: '输入个人信息文本',
    enterPersonalInformationText1: '输入个人信息文本',
    enterPersonalInformationText2: '输入个人信息文本',
    enterPersonalInformationText3: '输入个人信息文本',
    purposes: '收集个人信息的目的',
    enterPurposes: '输入目的文本',
    enterPurpose1: '输入目的 1',
    enterPurpose2: '输入目的 2',
    enterPurpose3: '输入目的 3',
    enterPurpose4: '输入目的 4',
    enterPurpose5: '输入目的 5',
    enterPurpose6: '输入目的 6',
    enterPurpose7: '输入目的 7',
    enterPurpose8: '输入目的 8',
    enterPurpose9: '输入目的 9',
    enterPurpose10: '输入目的 10',
    enterPurpose11: '输入目的 11',
    enterPurpose12: '输入目的 12',
    enterPurpose13: '输入目的 13',
    enterPurpose14: '输入目的 14',
    enterRecipientsText: '输入接收者文本',
    recipients: '个人信息的接收者',
    enterRecipients: '输入接收者文本',
    enterRecipient1: '输入接收者 1',
    enterRecipient2: '输入接收者 2',
    enterRecipient3: '输入接收者 3',
    enterRecipient4: '输入接收者 4',
    enterRecipient5: '输入接收者 5',
    enterRecipient6: '输入接收者 6',
    enterRecipient7: '输入接收者 7',
    enterUnsubscribe: '输入退订文本',
    enterUnsubscribeText: '输入退订文本',
    enterConsent: '输入同意文本',
    enterConsentText: '输入同意文本',
    enterContact: '输入联系文本',
    enterContactText: '输入联系文本',
    enterWebsiteNote: '输入网站说明'
  },
  termsAndConditions: {
    title: '条款和条件管理',
    content: '内容',
    heroTitle: '英雄标题',
    enterHeroTitle: '输入英雄标题',
    heroSubtitle: '英雄副标题',
    enterHeroSubtitle: '输入英雄副标题',
    lastUpdated: '最后更新',
    enterLastUpdated: '输入最后更新日期',
    part1Title: '第一部分标题',
    enterPart1Title: '输入第一部分标题',
    introduction: '介绍',
    enterIntroduction: '输入介绍文本',
    enterIntroductionText: '输入介绍文本',
    enterIntroductionText1: '输入介绍文本',
    enterIntroductionText2: '输入介绍文本',
    copyrightNotice: '版权声明',
    enterCopyrightNotice: '输入版权声明文本',
    enterCopyrightText: '输入版权文本',
    enterCopyrightText1: '输入版权文本',
    enterCopyrightText2: '输入版权文本',
    trademarkNotice: '商标声明',
    enterTrademarkNotice: '输入商标声明文本',
    enterTrademarkNoticeText: '输入商标声明文本',
    enterTrademarkText: '输入商标文本',
    acceptableUse: '可接受的使用',
    enterAcceptableUse: '输入可接受使用文本',
    enterAcceptableUseText1: '输入可接受使用文本',
    enterAcceptableUseText2: '输入可接受使用文本',
    enterAcceptableUseText3: '输入可接受使用文本',
    noWarranties: '无保证',
    enterNoWarranties: '输入无保证文本',
    enterNoWarrantiesText1: '输入无保证文本',
    noWarrantiesItem1: '无保证项目 1',
    enterNoWarrantiesItem1: '输入无保证项目 1',
    noWarrantiesItem2: '无保证项目 2',
    enterNoWarrantiesItem2: '输入无保证项目 2',
    noWarrantiesItem3: '无保证项目 3',
    enterNoWarrantiesItem3: '输入无保证项目 3',
    noWarrantiesItem4: '无保证项目 4',
    enterNoWarrantiesItem4: '输入无保证项目 4',
    noWarrantiesItem5: '无保证项目 5',
    enterNoWarrantiesItem5: '输入无保证项目 5',
    noWarrantiesItem6: '无保证项目 6',
    enterNoWarrantiesItem6: '输入无保证项目 6',
    noWarrantiesItem7: '无保证项目 7',
    enterNoWarrantiesItem7: '输入无保证项目 7',
    enterNoWarrantiesText2: '输入无保证文本',
    generalLimitation: '一般责任限制',
    enterGeneralLimitation: '输入一般责任限制文本',
    enterGeneralLimitationText1: '输入一般责任限制文本',
    enterGeneralLimitationText2: '输入一般责任限制文本',
    enterGeneralLimitationText3: '输入一般责任限制文本',
    enterGeneralLimitationText4: '输入一般责任限制文本',
    enterGeneralLimitationText5: '输入一般责任限制文本',
    thirdParties: '第三方',
    enterThirdParties: '输入第三方文本',
    enterThirdPartiesText1: '输入第三方文本',
    enterThirdPartiesText2: '输入第三方文本',
    thirdPartyTravelService: '第三方旅行服务提供商',
    enterThirdPartyTravelService: '输入第三方旅行服务文本',
    enterThirdPartyTravelServiceText1: '输入第三方旅行服务文本',
    enterThirdPartyTravelServiceText2: '输入第三方旅行服务文本',
    userComments: '用户评论',
    enterUserComments: '输入用户评论文本',
    enterUserCommentsText: '输入用户评论文本',
    responseToRequests: '对请求的响应',
    enterResponseToRequests: '输入对请求的响应文本',
    enterResponseToRequestsText: '输入对请求的响应文本',
    linksToOther: '指向其他网站的链接',
    enterLinksToOther: '输入指向其他网站的链接文本',
    enterLinksToOtherText: '输入指向其他网站的链接文本',
    terminationOfUsage: '使用终止',
    enterTerminationOfUsage: '输入使用终止文本',
    enterTerminationOfUsageText: '输入使用终止文本',
    pricingErrors: '定价错误',
    enterPricingErrors: '输入定价错误文本',
    enterPricingErrorsText1: '输入定价错误文本',
    enterPricingErrorsText2: '输入定价错误文本',
    enterPricingErrorsText3: '输入定价错误文本',
    creditCardSubmissions: '信用卡提交',
    enterCreditCardSubmissions: '输入信用卡提交流本',
    enterCreditCardSubmissionsText: '输入信用卡提交流本',
    membershipLoyalty: '会员和忠诚度计划',
    enterMembershipLoyalty: '输入会员忠诚度文本',
    enterMembershipLoyaltyText: '输入会员忠诚度文本',
    miscellaneous: '杂项',
    enterMiscellaneous: '输入杂项文本',
    enterMiscellaneousText1: '输入杂项文本',
    miscellaneousItem1: '杂项项目 1',
    enterMiscellaneousItem1: '输入杂项项目 1',
    miscellaneousItem2: '杂项项目 2',
    enterMiscellaneousItem2: '输入杂项项目 2',
    enterMiscellaneousText2: '输入杂项文本',
    enterMiscellaneousText3: '输入杂项文本',
    enterMiscellaneousText4: '输入杂项文本',
    enterMiscellaneousText5: '输入杂项文本',
    part2Title: '第二部分标题',
    enterPart2Title: '输入第二部分标题',
    limitationOfLiability: '责任限制',
    enterLimitationOfLiability: '输入责任限制文本',
    enterLimitationOfLiabilityText: '输入责任限制文本',
    ticketRestrictions: '机票限制',
    enterTicketRestrictions: '输入机票限制文本',
    enterTicketRestrictionsText: '输入机票限制文本',
    ticketPayment: '机票支付',
    enterTicketPayment: '输入机票支付文本',
    enterTicketPaymentText: '输入机票支付文本',
    otherServiceFee: '其他服务费',
    enterOtherServiceFee: '输入其他服务费文本',
    enterOtherServiceFeeText: '输入其他服务费文本',
    service: '服务',
    fee: '费用',
    service1: '预订费',
    service2: '取消费',
    service3: '更改费',
    serviceFeeManagement: '服务费用管理',
    addService: '添加服务',
    enterServiceName: '输入服务名称',
    enterServiceFee: '输入服务费用',
    noServicesAdded: '暂无服务项，请点击添加服务按钮',
    fuelSurcharge: '燃油附加费',
    enterFuelSurcharge: '输入燃油附加费文本',
    enterFuelSurchargeText: '输入燃油附加费文本',
    useOfTicket: '机票使用',
    enterUseOfTicket: '输入机票使用文本',
    enterUseOfTicketText1: '输入机票使用文本',
    enterUseOfTicketText2: '输入机票使用文本',
    enterUseOfTicketText3: '输入使用机票文本',
    enterUseOfTicketText4: '输入使用机票文本',
    refundPolicy: '退款政策',
    enterRefundPolicy: '输入退款政策',
    internationalTravel: '国际旅行',
    enterInternationalTravel: '输入国际旅行文本',
    enterInternationalTravelText: '输入国际旅行文本'
  }
}